<template>
  <div v-if="this.$store.state.Home.menuList.length">
    <!-- 头部导航栏 -->
    <ActNav></ActNav>
    <div class="about-left">
      <div>
        <div class="navlefttitle">关于我们</div>
        <ul class="leftList">
          <li
            v-for="item in menuMap"
            :key="item.id"
            @click="handleClickLeft(item.id)"
            :class="{ _activeli: actIndex == item.id }"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="newscontent">
        <Intro v-if="actIndex == 0"></Intro>
        <Leader v-if="actIndex == 1"></Leader>
        <Organization v-if="actIndex == 2"></Organization>
        <Regulations v-if="actIndex == 3"></Regulations>
      </div>
    </div>
  </div>
</template>

<script>
import ActNav from "@/components/ActNav";
import Intro from "@/components/about/intro";
import Leader from "@/components/about/Leader";
import Organization from "@/components/about/Organization";
import Regulations from "@/components/about/Regulations";

export default {
  name: "AboutPage",
  components: {
    ActNav,
    Intro,
    Leader,
    Organization,
    Regulations
  },
  data() {
    return {
      actIndex: ""
    };
  },
  watch: {
    $route(to, from) {
      to.path != from.path ? this.handleClickLeft(to.path.split("/")[2]) : "";
    }
  },
  computed: {
    pathTwo() {
      return this.$route.path.split("/")[2];
    },
    menuMap() {
      const subNav = this.$store.state.Home.menuList.filter(
        i => i.key === "about"
      )[0].subNav;
      return subNav;
    }
  },
  methods: {
    handleClickLeft(id) {
      this.actIndex = id;
      this.$router.push(`/about/${id}`);
    }
  },
  mounted() {
    this.handleClickLeft(this.pathTwo);
  }
};
</script>

<style lang="scss" scoped>
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

._activeli {
  color: #c52e0f !important;
  cursor: pointer !important;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.about-left {
  @extend %mgto;
  width: 1200px;
  @include displayflex(space-between, flex-start, row, nowrap);
  & > div:nth-child(1) {
    width: 250px;
    height: 820px;
  }
}

$pd-lf: padding-left;
.navlefttitle {
  background: url("../assets/newsnav_img1.png");
  background-size: 100% 100%;
  width: 100%;
  height: 80px;
  @include font-style("PingFangSC-Semibold", 24px, #ffffff, 600);
  @include displayflex(flex-start, center, row, nowrap);
  padding-left: 31px;
  box-sizing: border-box;
}
.leftList {
  @extend %ulst;
  margin-top: 10px;
  border-bottom: 4px solid #c52e0f;
  padding-bottom: 24px;
  width: 100%;
  background: #ffffff;
  & > li {
    width: 100%;
    height: 53px;
    @extend .box-border;
    #{$pd-lf}: 31px;
    @include displayflex(flex-start, center, row, nowrap);
    @include font-style("PingFangSC-Semibold", 18px, #3a3a3a, 600);
    border-bottom: 1px solid #dbdbdb;
    cursor: pointer !important;
    &:hover {
      background-color: #c52e0f !important;
      color: #ffffff !important;
      cursor: pointer !important;
    }
  }
}
.newscontent {
  width: 934px;
  margin-bottom: 40px;
  background: rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue